import SubscribeModal from './SubscribeModal';

export default SubscribeModal;
